import { TDictionary } from '../../../util/types'

type StatusDictionary = TDictionary<'idle' | 'pending' | 'fulfilled'>

export interface SalesState {
  agreements: TDictionary<TDictionary<SalesAgreement>>
  agreementsStatus: StatusDictionary
  orders: TDictionary<SalesOrderProps[]>
  orderStatus: StatusDictionary
}

export interface SalesAgreementApiEntity {
  id: string
  title: string
  startDate: Date
  endDate: Date
  status: string
  classification: string
  deliveryMode?: string
  carrier?: string
  deliveryAddress?: string
  lines: SalesAgreementProductLine[]
  supportsDelivery: boolean
  deliveryRequiresReview: boolean
}

export interface SalesAgreementProductLine {
  productVariantNumber: string
  productDescription: string
  quantity: {
    committed: number
    released: number
    delivered: number
    invoiced: number
    remaining: number
  }
  unit?: string
  unitPrice?: number
  netWeight?: number
}

export interface SalesAgreement extends SalesAgreementApiEntity {
  totalFulfilled: number
  totalCommitted: number
  totalReleased: number
  totalInvoiced: number
  percentageFulfilled: number
}

export interface SalesLine {
  itemNumber: number
  productVariantNumber: string
  description: string
  category: string
  committed: number
  released: number
  delivered: number
  invoiced: number
  unit: string
  unitPrice: number
}

interface SalesOrderProductsEntity {
  productVariantNumber: string
  productDescription: string
  amount: number
  unit: string
}
interface SalesOrderApiEntity {
  id: string
  date: Date | string
  status: string
  products: SalesOrderProductsEntity[]
}

export interface SalesOrderApiResponse {
  orders: SalesOrderApiEntity[]
}

export type SalesAgreementApiResponse = { salesAgreements: SalesAgreementApiEntity[] }
export type SalesLineProps = SalesAgreementProductLine
export type SalesAgreementProps = SalesAgreement
export type SalesOrderProps = SalesOrderApiEntity
export interface GetAgreementsReducerAction {
  data: TDictionary<SalesAgreement>
  accountNumber: string
}

export interface GetOrdersReducerAction {
  data: SalesOrderApiEntity[]
  agreementId: string
}
